import { INPUT_NAME_RESERVED_CANVAS_ARR } from './canvas/constants';
import { INPUT_NAME_RESERVED_GROUP_ARR } from './group/constants';

export const INPUT_NAME_RESERVED_ARR = [
  ...INPUT_NAME_RESERVED_CANVAS_ARR,
  ...INPUT_NAME_RESERVED_GROUP_ARR,
] as const;
